import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
    inputTicket : {
      fontFamily: 'Roboto,sans-serif',
      fontStyle: 'normal',
      fontWeight: '500',
      fontSize: '16px',
      lineHeight: '19px',
      color: '#fff',
    },
    labelTicket : {
      fontFamily: "Poppins, sans-serif",
      fontStyle: "normal",
      fontWeight: '500',
      fontSize: '13px',
      lineHeight: '19px',
      alignItems: "center",
      order: 1,
      flexGrow: '0',
      margin: '0px 8px',
      padding: '0.5em',
      background: 'rgb(9, 83, 140)',
      borderRadius: '0.5em',
      color: '#fff',
      display: 'flex',
      flexDirection: 'rowReverse',
      '& #Inactive':{
        color:"#fff !important"
      },
      '&> p':{
        marginTop: "3px !important",
        fontSize: "14px !important",
        fontWeight: "bold !important",
        marginLeft: "0.7em !important",
        wordBreak: 'break-all !important',
      },
    },
    infoTicket : {
      display: "flex",
      alignContent: "center",
      alignItems: "center",
    },
    infoContainer : {
      display: 'flex',
      alignItems: 'center'

    }
    
  }))

export default useStyles
